import { Globe, MoreHorizontal, Phone, UserCheck } from 'lucide-react';
import { Input } from '../ui/input';

export const ORIGINES = [
  { value: 'telephone', label: 'Contact par téléphone', icon: Phone },
  { value: 'formulaire_site', label: 'Formulaire contact site FISL', icon: Globe },
  { value: 'inscrit_site', label: 'Inscrit sur le site FISL', icon: UserCheck },
  { value: 'autre', label: 'Autres', icon: MoreHorizontal },
];

// Libellé de l'origine d'un prospect (les auto-inscriptions comptent comme « Inscrit sur le site FISL »)
export const libelleOrigine = (p) => {
  const o = p.origine || (p.created_by === 'auto_inscription' ? 'inscrit_site' : null);
  if (!o) return null;
  if (o === 'autre') return `Autres${p.origine_autre ? ` : ${p.origine_autre}` : ''}`;
  return ORIGINES.find(x => x.value === o)?.label || null;
};

// Choix de l'origine du prospect (boutons) + champ libre pour « Autres »
export const OriginePicker = ({ formData, setFormData }) => (
  <div className="rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid="origine-prospect">
    <p className="mb-2 text-sm font-medium text-slate-700">D'où arrive le prospect ?</p>
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {ORIGINES.map(({ value, label, icon: Icon }) => {
        const actif = formData.origine === value;
        return (
          <button key={value} type="button" onClick={() => setFormData({ ...formData, origine: actif ? '' : value })}
            className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-left text-xs font-medium transition-colors ${actif ? 'border-[#8DC63F] bg-[#8DC63F] text-white' : 'border-slate-200 bg-white text-slate-700 hover:border-[#8DC63F]'}`}
            data-testid={`origine-${value}`}>
            <Icon className="h-4 w-4 shrink-0" /> {label}
          </button>
        );
      })}
    </div>
    {formData.origine === 'autre' && (
      <Input className="mt-2 bg-white" placeholder="Précisez (salon, bouche-à-oreille, réseau social…)" value={formData.origine_autre || ''}
        onChange={e => setFormData({ ...formData, origine_autre: e.target.value })} data-testid="input-origine-autre" />
    )}
  </div>
);
